<div class="page-container">
  <header class="header">
    <div class="logo-container">
      <img
        src="static-files/logo-new/ONE-BY-CLARILOG-BLEU-v4.svg"
        class="logo logo-blue"
      />
    </div>
    <div class="nav-bar-content">
      <dx-toolbar class="navbar">
        <!--<dxi-item location="before">
          <cl-breadcrumb></cl-breadcrumb>
        </dxi-item>-->
        <dxi-item location="before">
          <div class="cl-alert-items">
            <cl-warning-customer-item></cl-warning-customer-item>
            <cl-warning-message-item></cl-warning-message-item>
            <cl-layout-message-item></cl-layout-message-item>
          </div>
        </dxi-item>

        <dxi-item location="center" class="cl-textbox-search">
          <dx-text-box
            #searchText
            [placeholder]="'globals/search' | translate"
            mode="search"
            width="500px"
            [visible]="showFieldSearch"
            (onFocusIn)="onSearchTextFocusIn($event)"
            (onFocusOut)="onSearchTextFocusOut($event)"
            (onInitialized)="onSearchTextInitialized($event)"
            (onKeyUp)="keyUp.next($event)"
            (onKeyDown)="onSearchTextKeyDown($event)"
          >
          </dx-text-box>
        </dxi-item>
        <dxi-item location="after">
          @if (viewHelpMe === false) {
            <div #alertContainer>
              <clc-alert *clcHasPolicies="['alert.read']"></clc-alert>
              <dx-tooltip
                [target]="alertContainer"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                position="bottom"
                [wrapperAttr]="{ class: 'cl-alert-tooltip' }"
              >
                <div *dxTemplate="let data of 'content'">
                  {{ 'entities/alert/_title/plural' | translate }}
                </div>
              </dx-tooltip>
            </div>
          }
        </dxi-item>
        <dxi-item location="after">
          @if (viewHelpMe === false && canViewNotification === true) {
            <div #notifContainer>
              <clc-notification [state]="state"></clc-notification>
              <dx-tooltip
                [target]="notifContainer"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                position="bottom"
                [wrapperAttr]="{ class: 'cl-alert-tooltip' }"
              >
                <div *dxTemplate="let data of 'content'">
                  {{ 'entities/notification/_title/plural' | translate }}
                </div>
              </dx-tooltip>
            </div>
          }
        </dxi-item>
        <dxi-item location="after">
          @if (viewHelpMe === false && canViewNotification === true) {
            <div #backgroundtaskContainer>
              <clc-background-task [state]="state"></clc-background-task>
              <dx-tooltip
                [target]="backgroundtaskContainer"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                position="bottom"
                [wrapperAttr]="{ class: 'cl-alert-tooltip' }"
              >
                <div *dxTemplate="let data of 'content'">
                  {{ 'entities/scheduleTask/backgroundTask' | translate }}
                </div>
              </dx-tooltip>
            </div>
          }
        </dxi-item>
        <dxi-item location="after">
          <dx-menu (onItemClick)="itemMenuClick($event)" [items]="menuItems">
            <div *dxTemplate="let item of 'item'">
              @if (item.key === 'profile') {
                <div class="user-profile-container">
                  <div class="user-initials-badge">{{ getUserInitials() }}</div>
                  <!--<span class="user-fullname">{{ item.text }}</span>-->
                </div>
              }
              @if (item.key !== 'profile') {
                <span class="menu-item-text">
                  {{ item.text }}
                </span>
              }
            </div>
          </dx-menu>
        </dxi-item>
      </dx-toolbar>
    </div>
    @if (isOpened) {
      <div
        (clickOutside)="onClickedOutside($event)"
        [clickOutsideEnabled]="isClickOutsideEnabled"
        [clickOutsideEvents]="['pointerdown']"
        (pointerdown)="onRightNavPointerDown()"
        (pointerup)="onRightNavPointerUp()"
        #rightNav
        class="right-nav"
        [ngClass]="{ open: isOpened }"
      >
        <div class="close-btn">
          <a href="javascript:void(0)" class="close-btn" (click)="close()"
            ><i class="fal fa-times"></i
          ></a>
        </div>
        <cl-ticket-refresh-delay
          [delay]="ticketRefreshDelay"
          [isTicketRefreshEnabled]="isTicketRefreshEnabled"
        ></cl-ticket-refresh-delay>
        <cl-lang-switcher
          [langs]="langs"
          [value]="currentLang"
          [buttonText]="'globals/languages' | translate"
        ></cl-lang-switcher>
        <cl-theme-switcher
          [buttonText]="'themeMode/hint' | translate"
        ></cl-theme-switcher>
        <cl-panel-reader-switcher
          [value]="panelReader"
        ></cl-panel-reader-switcher>
        <cl-panel-reader-size [size]="panelReaderSize"></cl-panel-reader-size>
        <div class="refresh-btn-wrapper">
          <dx-button
            text="{{ 'apply' | translate }}"
            stylingMode="text"
            icon="check"
            [width]="200"
            (onClick)="reloadPage()"
          ></dx-button>
        </div>
      </div>
    }
  </header>

  <div class="grid-container">
    <aside class="side-nav">
      <div class="menu-container">
        <clc-nav-menu-push
          style="background-color: var(--features-nav-bar-bg)"
        ></clc-nav-menu-push>
      </div>
    </aside>
    <main class="content">
      <div class="container">
        <router-outlet
          class="body"
          (activate)="onOutletLoaded($event)"
        ></router-outlet>
      </div>
    </main>
  </div>
</div>

@if (showItemSearch) {
  <dx-popover
    class="cl-popover"
    [position]="{
      my: 'left top',
      at: 'left bottom',
      of: itemSearchTextElement,
      collision: { x: 'flip', y: 'flip' },
    }"
    width="500px"
    [(visible)]="showItemSearch"
  >
    <dx-load-indicator [visible]="isSearchLoading"></dx-load-indicator>
    <dx-list
      [elementAttr]="{ class: 'cl-search-list-search' }"
      [visible]="!isSearchLoading"
      [items]="itemsSearch"
      displayExpr="title"
      keyExpr="id"
      selectionMode="all"
      selectAllMode="page"
      [showSelectionControls]="true"
      [(selectedItemKeys)]="selectedItemsSearch"
    >
    </dx-list>
  </dx-popover>
}

@if (showResultSearch) {
  <dx-popover
    class="cl-popover"
    (onHidden)="onResultSearchHidden($event)"
    [position]="{
      my: 'left top',
      at: 'left bottom',
      of: itemSearchTextElement,
      collision: { x: 'flip', y: 'flip' },
    }"
    width="500px"
    [(visible)]="showResultSearch"
  >
    <dx-load-indicator
      class="cl-search-load"
      [visible]="isSearchLoading"
    ></dx-load-indicator>
    <dx-list
      #searchResultList
      [visible]="!isSearchLoading"
      class="cl-list-search-result"
      [dataSource]="sourceSearch"
      keyExpr="id"
      selectionMode="none"
      selectAllMode="page"
      [grouped]="true"
      [collapsibleGroups]="false"
      (onItemClick)="onSearchResultItemClick($event)"
    >
      <div *dxTemplate="let item of 'group'">
        <div
          class="cl-list-item-group"
          (click)="onItemGroupClick(item)"
          (auxclick)="onItemGroupAuxClick(item)"
        >
          <i [class]="item.icon"></i> {{ item.key }}
        </div>
      </div>
      <div *dxTemplate="let item of 'item'" class="item-search-result">
        @switch (item.__typename) {
          @case ('Asset') {
            <div>
              <div>
                {{ item.name }}
                @if (item.assetStatus?.data?.name != undefined) {
                  <div
                    class="cl-asset-search-status"
                    [ngClass]="
                      item.assetStatus?.data?.key === 'out-of-park'
                        ? 'cl-asset-search-status-out'
                        : 'cl-asset-search-status-inservice'
                    "
                  >
                    {{
                      getTranslateField(
                        $safeNavigationMigration(item.assetStatus?.data?.name)
                      )
                    }}
                  </div>
                }
              </div>
              <span
                >{{
                  getTranslateField(
                    $safeNavigationMigration(item.assetCategory?.data?.name)
                  )
                }}
              </span>
              @if (item.ipAddress != undefined) {
                <span> \ {{ item.ipAddress }}</span>
              }
            </div>
          }
          @case ('Software') {
            <div>
              <span
                >{{
                  'enums/softwareCategory/' + item.softwareCategory | translate
                }}
              </span>
              <div>{{ item.name }}</div>
            </div>
          }
          @case ('Incident') {
            <div>
              <div>{{ item.title }}</div>
              <span>
                {{ 'entities/incident/ticketNumber' | translate }} :
                {{ item.ticketNumber }}
              </span>
              @if (
                $safeNavigationMigration(item.userAffected?.data?.name) !== null
              ) {
                <span>
                  | {{ 'entities/incident/userAffected' | translate }} :
                  {{ item.userAffected?.data?.name }}
                </span>
              }
            </div>
          }
          @case ('Request') {
            <div>
              <div>{{ item.title }}</div>
              <span>
                {{ 'entities/incident/ticketNumber' | translate }} :
                {{ item.ticketNumber }}
              </span>
              @if (
                $safeNavigationMigration(item.userAffected?.data?.name) !== null
              ) {
                <span>
                  | {{ 'entities/incident/userAffected' | translate }} :
                  {{ item.userAffected?.data?.name }}
                </span>
              }
            </div>
          }
          @case ('Change') {
            <div>
              <div>{{ item.title }}</div>
              <span>
                {{ 'entities/change/ticketNumber' | translate }} :
                {{ item.ticketNumber }}
              </span>
              @if (
                $safeNavigationMigration(item.userMakeRequest?.data?.name) !==
                null
              ) {
                <span>
                  | {{ 'entities/change/userMakeRequest' | translate }} :
                  {{ item.userMakeRequest?.data?.name }}
                </span>
              }
            </div>
          }
          @case ('Problem') {
            <div>
              <div>{{ item.title }}</div>
              <span>
                {{ 'entities/incident/ticketNumber' | translate }} :
                {{ item.ticketNumber }}
              </span>
            </div>
          }
          @case ('ArticleKnowledge') {
            <div>
              <div>{{ getTranslateField(item.title) }}</div>
            </div>
          }
          @case ('User') {
            <div>
              <div>{{ item.name }}</div>
              <span>{{ item.email }}</span>
            </div>
          }
          @case ('Contract') {
            <div>
              <span
                >{{
                  getTranslateField(
                    $safeNavigationMigration(item.contractCategory?.data?.name)
                  )
                }}
              </span>
              <div>{{ item.name }}</div>
            </div>
          }
          @case ('Loan') {
            <div>
              <div>
                {{ 'entities/loan/_title/singular' | translate }} :
                {{ item.number }}
              </div>
            </div>
          }
          @default {
            <div>
              {{ getTranslateValue(item.name) }}
            </div>
          }
        }
      </div>
    </dx-list>
  </dx-popover>
}

@if (showFeedback) {
  <dx-popup
    [width]="800"
    [height]="'80%'"
    [showTitle]="false"
    class="add-item-popup"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="true"
    [deferRendering]="true"
    [(visible)]="showFeedback"
  >
    <clc-work-form
      [model]="modelFeedback"
      [service]="feedbackService"
      [displaySaveIcon]="false"
      (onSubmit)="onSubmit($event)"
      [showBack]="false"
      [successMessage]="'globals/sendFeedback'"
      [navigateAfterSave]="false"
      [saveTilte]="'globals/send'"
      [saveSplitButton]="false"
    >
    </clc-work-form>
  </dx-popup>
}

<clc-viewer-popup
  [(showViewer)]="showViewer"
  [showEvaluateZone]="'ArticleKnowledgeNoteCoreService'"
  [titleTranslatable]="true"
  [countService]="'ArticleKnowledgeCoreService'"
  [serviceName]="'ArticleKnowledgeCoreService'"
  [id]="idEntity"
  [icon]="'fal fa-book-open'"
  [color]="'rgb(var(--headband-color))'"
  [secondColor]="'rgb(var(--primary-color))'"
  [countMethodeService]="'countViewByOperator'"
></clc-viewer-popup>
